import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { obtenerDetallePorCosecha } from '../../actions/listados'
import DetalleConsultaPorCosechaView from '../../components/controlExistencias/DetalleConsultaPorCosechaView'

function DetalleConsultaPorCosecha (props) {
  const { detalle, obtenerDetallePorCosecha, fechaDesde, fechaHasta } = props

  useEffect(() => {
    obtenerDetallePorCosecha(fechaDesde, fechaHasta, detalle.cereal, detalle.cosecha, detalle.cerealVariedad)
  }, [detalle, fechaDesde, fechaHasta, obtenerDetallePorCosecha])

  return (
    <>
      <DetalleConsultaPorCosechaView />
    </>
  )
}

const mapStateToProps = (state) => ({
  fechaDesde: state.stock.fechaDesde,
  fechaHasta: state.stock.fechaHasta
})

const mapActionsToProps = {
  obtenerDetallePorCosecha
}

const withRedux = connect(mapStateToProps, mapActionsToProps)
export default withRedux(DetalleConsultaPorCosecha)
